import React from "react";
import "../GettingStarted.css";
import "./MinimizedView.css";
import useAdminDataStore, { selectGettingStartedExpanded } from "../../../store/adminData/adminData";
import closeIcon from "../../../images/close-icon.svg";

const MinimizedView = () => {
  const expanded = useAdminDataStore(selectGettingStartedExpanded);
  const setGettingStartedExpanded = useAdminDataStore(
    (state) => state.setGettingStartedExpanded,
  );

  const handleExpand = (value) => {
    setGettingStartedExpanded(value);
  };

  return (
    <div
      className="get-started-minimized"
      onClick={() => handleExpand(!expanded)}
    >
      <div className="get-started-minimized-text">
        <div
          className={`get-started-minimized-text--expanded ${expanded ? "visible" : ""}`}
        >
          <img
            height={28}
            width={28}
            alt="Close Getting Started"
            src={closeIcon}
          />
        </div>
        {/* <div
          className={`get-started-minimized-text--minimized ${expanded ? "" : "visible"}`}
        >
          Get Started
        </div> */}
      </div>
    </div>
  );
};

export default MinimizedView;
